import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import { presentationOptions } from '@/constants/states';
import CardsHeader from '@/components/cards/CardsHeader';
import paging, { onCategoryScroll } from '@/hooks/paging';
import UsersTable from '../components/UsersTable';
import UsersPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/UsersPanelContainer';
import UserCards from '../components/UserCards';
import UsersFilters from './UsersFilters';

const UsersPanelFull = ({
  allowRoleLink,
  canRead,
  category,
  currentPage,
  display,
  fetchData,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  togglePresentation,
  total,
  users,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus);
  return (
    <UsersPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-users-panel-full">
      {display === presentationOptions.CARDS && (
      <>
        <CardsHeader
          disabled={readStatus === states.PENDING}
          onClick={() => togglePresentation(category, presentationOptions.TABLE)}
        >
          <UsersFilters category={category} className="aridhia-list-filter" />
        </CardsHeader>
        <UserCards
          allowApprovedStatus
          allowRoleLink={allowRoleLink}
          allowTools
          allowUserLink
          category={category}
          handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
          items={users}
          onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
          readErrors={readErrors}
          readStatus={readStatus}
        />
      </>
      )}
      {display !== presentationOptions.CARDS && (
      <UsersTable
        allowRoleLink={allowRoleLink}
        category={category}
        currentPage={currentPage}
        fetchData={fetchData}
        onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
        pageCount={pageCount}
        pageSize={pageSize}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
        users={users}
      />
      )}
    </UsersPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPanelFull);
